import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AdminService } from '../../services/AdminService/admin';
import { CreateUserRequest } from '../../models/company.dto';
import { Role } from '../../models/auth.dto';
import { extractErrorMessage } from '../../shared/error-utils';
import { ErrorBanner } from '../../shared/components/error-banner/error-banner';

const PLATFORM_ROLES: Role[] = ['ADMIN', 'CUSTOMS', 'AUDITOR'];

@Component({
  selector: 'app-create-user-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    ErrorBanner,
  ],
  templateUrl: './create-user-dialog.html',
  styleUrl: './create-user-dialog.scss',
})
export class CreateUserDialog {
  roles = PLATFORM_ROLES;

  form: CreateUserRequest = { email: '', password: '', fullName: '', role: 'ADMIN' };
  isSubmitting = signal(false);
  errorMessage = signal('');

  constructor(private dialogRef: MatDialogRef<CreateUserDialog>, private admin: AdminService) {}

  get canSubmit(): boolean {
    return !!this.form.email.trim() && this.form.password.length >= 8 && !!this.form.fullName.trim();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    if (!this.canSubmit) {
      return;
    }

    this.isSubmitting.set(true);
    this.errorMessage.set('');

    this.admin.createUser(this.form).subscribe({
      next: () => {
        this.isSubmitting.set(false);
        this.dialogRef.close(true);
      },
      error: (err: HttpErrorResponse) => {
        this.isSubmitting.set(false);
        this.errorMessage.set(extractErrorMessage(err, 'Failed to create user.'));
      },
    });
  }
}
